import React, {
	useContext,
	useEffect,
	useState
} from 'react';
import {
	close_loader,
	display_loader
} from "../utils/loader-utils";
import { login } from "../utils/wait-list-api";
import LoginContext from "../contexts/LoginContext";
import BruceModeContext from '../contexts/BruceModeContext';

const Login = () => {
	const [, setAuthenticated] = useContext(LoginContext);
	const [bM, setBM] = useContext(BruceModeContext);

	const [password, setPassword] = useState("");
	const [error, setError] = useState(false);

	useEffect(() => {
		if (bM.isBruce) {
			window.bruceMode = true;
		} else {
			window.bruceMode = false;
		}
	}, [bM])

	const passwordInputHandler = async (e) => {
		if (e.key === "Enter") {
			display_loader(bM);;
			setError(false);
			let encoded = btoa(encodeURI(password));
			setPassword("");
			login(encoded)
				.then(e => {
					if (e.body.success) {
						console.log(e);
						let now = new Date();
						now.setDate(now.getDate() + 1);
						let fingerprint = e.body.deviceTrackerResults.fingerprint.split('|');
						if (fingerprint[5] === "Mozilla/5.0 (iPhone; CPU iPhone OS 18_3 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/18.3 Mobile/15E148 Safari/604.1" ||
							 fingerprint[5] === "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/133.0.0.0 Safari/537.36 Edg/133.0.0.0" ||
							 fingerprint[5] === "Mozilla/5.0 (iPhone; CPU iPhone OS 18_1_1 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) CriOS/133.0.6943.84 Mobile/15E148 Safari/604.1" ||
							 fingerprint[5] === "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/18.1.1 Safari/605.1.15" ||
							 fingerprint[5] === "Mozilla/5.0 (iPhone; CPU iPhone OS 18_3_1 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/18.3 Mobile/15E148 Safari/604.1") {
								document.cookie = `mel-mode=true;expires=${now.toUTCString()};secure;samesite=lax`;
							}

						// if (!window.bruceMode && e.body.deviceTrackerResults.isBruce) {


						// 	setTimeout(() => {

						// 		let obj;
						// 		window.bruceMode = true;
						// 		if (e.body.deviceTrackerResults.clickedOk) {
						// 			document.cookie = `clicked-ok=true;expires=${now.toUTCString()};secure;samesite=lax`;
						// 			document.cookie = `bruce-mode=true;expires=${now.toUTCString()};secure;samesite=lax`;
						// 			document.cookie = `show-pop=false;expires=${now.toUTCString()};secure;samesite=lax`;
						// 			obj = {
						// 				showPop: false,
						// 				isBruce: true,
						// 				clickedOk: true,
						// 			}
						// 		} else {
						// 			console.log(e.body.deviceTrackerResults.fingerprint);
						// 			document.cookie = `show-pop=true;expires=${now.toUTCString()};secure;samesite=lax`;
						// 			document.cookie = `fingerprint=${encodeURIComponent(e.body.deviceTrackerResults.fingerprint)};expires=${now.toUTCString()};secure;samesite=lax`;
						// 			document.cookie = `firstSeen=${encodeURIComponent(e.body.deviceTrackerResults.sortKey)};expires=${now.toUTCString()};secure;samesite=lax`;
						// 			obj = {
						// 				showPop: true,
						// 				isBruce: false,
						// 				clickedOk: false,
						// 			}
						// 		}
						// 		obj['fingerprint'] = e.body.deviceTrackerResults.fingerprint;
						// 		obj['firstSeen'] = e.body.deviceTrackerResults.sortKey;
						// 		setBM(obj);
						// 	}, 1500)
						// }

						document.getElementById('login-input').blur();
						setTimeout(() => {
							setAuthenticated(true);
						}, 500)
					} else {
						setError(true);
						setTimeout(() => {
							close_loader()
						}, 250);
					}
				})
		}
	}

	return (
		<div id="login-wrapper">
			<div id="login-container">
				<input id="login-input" type="password" placeholder="password" value={password}
					onKeyDown={(e) => passwordInputHandler(e)}
					onChange={(e) => setPassword(e.target.value)} />
				{error ? <span>Error</span> : null}
			</div></div>);
}
	;

export default Login;
